import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { LIST_TYPE, ROUTES, USER_TYPE } from '../constant'
import { getUsers } from '../actions/admin'
import { exportsUsersCSV } from '../actions/export'
import ListUser from '../components/ListUser'


class ListPhotographer extends Component {
  /* LIFECYCLE */

  state = {
    lastQuery: '',
    lastOptions: {},
  }


  /* METHODS */

  handleItemClick = (item) => {
    this.props.history.push(`${ROUTES.USER}/${item.objectID}`)
  }

  handleGetUsers = (query, options) => {
    const { list } = this.props

    this.props.getUsers(USER_TYPE.PHOTOGRAPHER, query, {
      sort: list.sort || '',
      ...options,
    })

    this.setState({
      lastQuery: query,
      lastOptions: options,
    })
  }

  handleExport = () => this.props.exportsUsersCSV(USER_TYPE.PHOTOGRAPHER)

  handleSortChange = (sort) => {
    const { lastQuery, lastOptions } = this.state

    return this.handleGetUsers(lastQuery, {
      ...lastOptions,
      sort,
    })
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      list,
      isLoading,
      isConnected,
    } = this.props

    return (
      <ListUser
        title="Photographer"
        isLoading={isLoading}
        isConnected={isConnected}
        onExport={this.handleExport}
        type={USER_TYPE.PHOTOGRAPHER}
        request={this.handleGetUsers}
        onItemClick={this.handleItemClick}
        onSortChange={this.handleSortChange}
        {...list}
      />
    )
  }
}


ListPhotographer.propTypes = {
  list: PropTypes.object,
  isConnected: PropTypes.bool,
  getUsers: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  exportsUsersCSV: PropTypes.object.isRequired,
}


const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
  isConnected: state.user.isConnected,
  list: state.list.collection === LIST_TYPE.MODEL ? state.list : {
    page: 0,
    count: 0,
    sort: '',
    items: [],
    totalPages: 0,
  },
})


export default connect(mapStateToProps, {
  getUsers,
  exportsUsersCSV,
})(ListPhotographer)
